module.exports = __webpack_public_path__ + "img/collection-weddingRingsBudgetLow@2x.e4d44ab.jpg";